/*
    Description: helper class for other classes
    Author URI: https://www.adillice.com
    Author: adillice
    Version: 1.0.0
*/

class Utility{

    // constructor
    constructor(){}

    // ajax call
    async ajax(obj){

        // meet requirements
        if(!obj || !obj.action || !ajax.url) return;

        // set defaults
        if(!obj.method) obj.method = "POST";
        if(!obj.data) obj.data = null;

        // set url
        const url = `${ajax.url}?action=${obj.action}`;
        
        // return promise
        return new Promise(function(resolve, reject){

            // create XMLHttpRequest instance
            var request = new XMLHttpRequest();
            
            // open request
            request.open(obj.method, url, true);
            
            // on state change
            request.onreadystatechange = function(){
              
                // ready
                if(request.readyState == 4){

                    // SUCCESS: repsonse
                    if(request.status == 200){

                        // resolve request
                        resolve(JSON.parse(request.responseText));
                    
                    // ERROR: response
                    }else{

                        // reject
                        reject(Error(request.statusText));
                        
                    }

                }

            };

            // request on error
            request.onerror = function(){
                
                // reject error
                reject(Error("an ajax error occurred."));
            
            };

            // send request with data 
            request.send(obj.data);
            
        });
            
    };

    // trap focus -- i.e., for overlays
    trapFocus(wrapper = null){
        
        // make sure we have a wrapper
        if(wrapper == null) return;
        
        // add keydown event listener for wrapper 
        wrapper.addEventListener("keydown", (e) => {
            
            // get current key
            const thisKey = e.key.toLowerCase() || e.keyCode,
            
            // get tabbable items we want
            indexList = wrapper.querySelectorAll('[tabindex]:not([tabindex="-1"]), input:not([type="hidden"]), select, textarea, button'),
            
            // get current active DOM element 
            active = document.activeElement,
            
            // get first DOM element
            first = indexList[0],
            
            // get last DOM element
            last = indexList[indexList.length - 1];
            
            // UP: tabbing up
            if(e.shiftKey && ((thisKey == 9)||(thisKey == "tab"))){
                
                // check active DOM element
                if(active == first && last){
                    
                    // prevent default 
                    e.preventDefault();

                    // set focus on last element
                    last.focus();

                } 

            // DOWN: tabbing down
            }else if((thisKey == 9)||(thisKey == "tab")){

                // check active DOM element
                if(active == last && first){

                    // prevent default 
                    e.preventDefault();

                    // set focus on first element
                    first.focus();
                    
                } 
                
            }

        });

    };

    // when enter is press close overlay [bttn:button than we are watching for enter press, callback:method to close overlay]
    pressEnterClose(bttn = null, callback = null){
        
        // end case
        if(bttn == null || callback == null) return;

        // get button
        const thisBttn = bttn,

        // get callback
        thisCallback = ((typeof callback === "function")) ? callback : null;

        // add key event
        thisBttn.addEventListener("keydown", (e) => {

            // get current key
            const thisKey = e.key.toLowerCase() || e.keyCode,

            // get active element
            active = document.activeElement;

            // check if focused DOM element is the close button and user has hit enter key
            if((active == thisBttn) && (thisKey == "enter" || thisKey == 13)){

                // fire callback
                if(thisCallback != null){

                    //fire call back
                    thisCallback(e);
                }
            
            }

        });

    }

}

// export default
export default Utility;